import styled from 'styled-components'

export const SearchInputContainer = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  position: relative;
`

export const StyledSearchInput = styled.input`
  width: 100%;
  height: ${(p) => {
    return p.height
  }};
  border: 1px solid rgba(32, 32, 32, 0.2);
  border-radius: 4px;
  line-height: 16px;
  padding: 8px 8px 8px 40px;
  outline: none;
  margin-bottom: 0;
  font-weight: 400;
  box-shadow: 0 1px 2px rgba(32, 32, 32, 0.05);
  font-family: Inter;

  &:focus {
    border: 1px solid #0aa1f4;
    box-shadow: 0px 1px 2px rgba(32, 32, 32, 0.05), 0px 0px 0px 4px rgba(10, 161, 244, 0.1);
    transition: box-shadow 0.1s ease-in-out;
  }
`

export const SearchInputIconWrapper = styled.div`
  height: 40px;
  padding: 8px 0 8px 8px;
  display: flex;
  align-items: center;
  position: absolute;
  left: 0;
`

export const SearchClearIconWrapper = styled.div`
  height: 24px;
  width: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  right: 8px;
  border-radius: 50%;

  :hover {
    background: rgba(32, 32, 32, 0.05);
  }

  &:hover svg path{
    fill-opacity: 1;
  }
`

export const SearchIconWrapper = styled.div`
  height: 40px;
  width: 40px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 8px;

  :hover {
    background: rgba(32, 32, 32, 0.05);      
  }
  
  &:hover svg path{
    fill-opacity: 1;
  }
`
